import Qs from "qs";

import { isObj } from '../type'
import { Location } from '../../interface'

export const createLocation = (href: Location | string): Location => {
    if (isObj(href)) {
        return href as Location
    }

    if (typeof href === 'string' && href) {
        const { origin, pathname, search } = new URL(href)

        return {
            origin,
            pathname,
            search,
            query: Qs.parse(search, { ignoreQueryPrefix: true }),
        }
    }

    return {
        origin: '',
        pathname: '',
        search: '',
        query: {},
    }
}
